import React, { useCallback, useMemo, useState } from "react";
import styled from "@emotion/styled";

import StationMap from "components/commons/station-map/station-map";
import { useMount } from "hooks";
import { Image, Text } from "components/commons";
import { dateFormat, formatCurrency, formatNumber } from "utils";

import styles from "./station-pricing.module.scss";

import locale from "localization";
import { sortByKeyName } from "utils/object.utils";
import { capitalizeWord } from "utils/text.utils";

const StationDetailsContainer = styled("div")`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const StationDetails = styled("div")`
  padding: 10px 20px;
  margin-top: 10px;
  width: 100%;
`;

const StationDetailsView = ({ stationData }) => {
  console.log(stationData);
  const {
    imageUrl,
    brand,
    station,
    capturedAt,
    address,
    priceCaptureProducts,
    priceCaptureStations,
    brandName,
  } = stationData;
  return (
    <StationDetailsContainer>
      <div className={styles?.detailPhotoContainer}>
        <Image src={imageUrl} />
      </div>
      <StationDetails>
        <Text className={styles?.subBusinessId}>
          <locale.Populate text={locale.asOfDate} items={[dateFormat(capturedAt)]} />
        </Text>
        <Text strong style={{ margin: "15px 0px" }}>
          {brand
            ? brandName
              ? `${locale.others} - ${brandName}`
              : brand?.brandName ?? ""
            : `${locale.seaoil} ${capitalizeWord(station?.name.replace("SEAOIL", ""))}`}
        </Text>

        <div className={styles.rowDetails}>
          <Text>{locale.location}</Text>
          <Text>{address}</Text>
        </div>

        {(brand || brandName) && (
          <div className={styles.rowDetails}>
            <Text>{locale.competitorOf}</Text>

            {priceCaptureStations.length === 0 ? (
              <Text>{locale.NA}</Text>
            ) : (
              <div className={styles.columnDetails}>
                {priceCaptureStations?.map((data) => (
                  <Text>{`${locale.seaoil} ${capitalizeWord(
                    data.name.replace("SEAOIL", "")
                  )}`}</Text>
                ))}
              </div>
            )}
          </div>
        )}

        <div style={{ display: "flex", gap: 100 }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Text style={{ margin: "15px 0px", color: "#95a2aa" }}>{locale.products}</Text>
            {priceCaptureProducts?.map((data) => (
              <Text>{data?.productName}</Text>
            ))}
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Text style={{ margin: "15px 0px", color: "#95a2aa" }}>{locale.pumpPrice}</Text>
            {priceCaptureProducts?.map((data) => (
              <Text>{formatCurrency(data?.price)}</Text>
            ))}
          </div>
        </div>
      </StationDetails>
    </StationDetailsContainer>
  );
};

const StationMapView = ({ stations: data = [] }) => {
  const [currentLocation, setCurrentLocation] = useState(null);
  const [allowAccessLocation, setAllowAccessLocation] = useState(true);
  // const [pinnedMap, setPinnedMap] = useState(null);
  const [selectedStation, setSelectedStation] = useState(null);

  const stations = useMemo(() => {
    const existing = [];
    const eAddress = [];
    return data
      .sort(sortByKeyName("priceCaptureId"))
      .reverse()
      .filter(({ latitude, longitude }) => {
        const geo = `${formatNumber(latitude, 12)}-${formatNumber(longitude, 12)}`;
        if (!existing.includes(geo)) {
          existing.push(geo);
          return true;
        }
        return false;
      })
      .filter(({ address }) => {
        if (!eAddress.includes(address)) {
          eAddress.push(address);
          return true;
        }
        return false;
      });
  }, [data]);

  const getCurrentPosition = useCallback(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        if (position) {
          setCurrentLocation({
            lat: Number(position.coords.latitude),
            lng: Number(position.coords.longitude),
          });
        }
      },
      () => {
        setAllowAccessLocation(false);
      }
    );
  }, []);

  useMount(() => {
    getCurrentPosition();
  });

  return (
    <>
      <StationMap
        currentLocation={currentLocation}
        allowAccessLocation={allowAccessLocation}
        stations={stations}
        // pinnedMap={pinnedMap}
        setSelectedStation={setSelectedStation}
        // setPinnedMap={setPinnedMap}
        selectedStation={selectedStation}
      >
        {selectedStation !== null && <StationDetailsView stationData={stations[selectedStation]} />}
      </StationMap>
    </>
  );
};

export default StationMapView;
